import { createFileRoute } from '@tanstack/react-router';

import { AdminPlansView } from 'src/sections/admin/plans/AdminPlansView';

export const Route = createFileRoute('/admin-skidog/plans')({
  component: AdminPlansPage,
});

function AdminPlansPage() {
  return <AdminPlansView />;
}
